import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ReactResizeDetector from 'react-resize-detector';

import CTAGetStarted from '../components/cta/GetStarted';

import Hero from './health/Hero';
import ConditionsList from './health/ConditionsList';
import IndexSearch from './health/IndexSearch';

import { withAppContext } from '../contexts/app';
import { withConditionsData } from '../contexts/conditionsData';

import { MobileTabletOnly, DesktopUp } from 'shared/Responsive';

class Health extends Component {
  constructor(props) {
    super(props);

    this.state = {
      conditionsLoaded: false,
      letters: [],
      conditions: {}
    };

    this.onScroll = this.onScroll.bind(this);
  }

  async componentDidMount() {
    window.addEventListener('scroll', this.onScroll);

    // Loading conditions data from S3 if not yet loaded
    if (!this.props.conditionsData.conditions) {
      await this.props.conditionsData.loadConditions();
    }

    this.setState({
      conditionsLoaded: true,
      letters: this.props.conditionsData.letters,
      conditions: this.props.conditionsData.all({ byLetter: true })
    });
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll);
  }

  render() {
    const indexSearchDefaultProps = {
      id: 'index-search',
      className: 'index-search',
      letters: this.state.letters
    };

    return (
      <div className="health-view">
        <Hero className="hero" />

        <MobileTabletOnly>
          <IndexSearch {...indexSearchDefaultProps} onSearch={this.onSearch.bind(this, 0)} />
        </MobileTabletOnly>

        <DesktopUp>
          <IndexSearch {...indexSearchDefaultProps} onSearch={this.onSearch.bind(this, 10)} />
        </DesktopUp>

        { this.state.conditionsLoaded &&
          <ConditionsList
            id="conditions-list"
            className="conditions-list"
            conditions={this.state.conditions}
          />
        }

        <CTAGetStarted />

        <ReactResizeDetector handleHeight onResize={this.onScroll.bind(this)} />
      </div>
    );
  }

  onSearch(scrollOffset, searchTerm) {
    const conditions = this.props.conditionsData.search(searchTerm, { byLetter: true });

    this.setState({
      letters: Object.keys(conditions),
      conditions: conditions
    }, () => {
      // Depending on whether mobile or desktop, there'll be slightly different offsets where to scroll to
      this.scrollToItem('conditions-list', scrollOffset);
    });
  }

  onScroll() {
    const indexSearchEl = document.getElementById('index-search');

    const defaultIndexSearchTop = indexSearchEl.previousSibling.offsetTop + indexSearchEl.previousElementSibling.offsetHeight;

    // Setting index and search bar positioning depending on how far the users crollined in the page
    if (defaultIndexSearchTop - window.scrollY < 1) {
      indexSearchEl.style.position = 'fixed';
      indexSearchEl.nextSibling.style.marginTop = indexSearchEl.offsetHeight + 'px';
    } else {
      indexSearchEl.style.position = 'relative';
      indexSearchEl.nextSibling.style.marginTop = 0;
    }
  }

  scrollToItem(id, scrollOffset) {
    const element = document.getElementById(id);

    if (!element) { return; }

    const elementPosition = window.pageYOffset + element.getBoundingClientRect().top;
    const targetPositon = elementPosition - document.getElementById('index-search').getBoundingClientRect().height + scrollOffset;

    window.scrollTo({ top: targetPositon, behavior: 'auto' });
  }
}

Health.defaultProps = {};
Health.propTypes = {
  app: PropTypes.object.isRequired,
  conditionsData: PropTypes.object.isRequired,
};

export default withAppContext(withConditionsData(Health));
